import React, { createContext, useContext, useState, useEffect } from 'react';

const DisputeContext = createContext();

export const useDispute = () => {
  const context = useContext(DisputeContext);
  if (!context) {
    throw new Error('useDispute must be used within DisputeProvider');
  }
  return context;
};

export const DisputeProvider = ({ children }) => {
  const [dispute, setDispute] = useState(() => {
    // Load from localStorage if available
    const saved = localStorage.getItem('dispute');
    return saved ? JSON.parse(saved) : null;
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Persist to localStorage whenever dispute changes
  useEffect(() => {
    if (dispute) {
      localStorage.setItem('dispute', JSON.stringify(dispute));
    } else {
      localStorage.removeItem('dispute');
    }
  }, [dispute]);

  const updateDispute = (updates) => {
    setDispute((prev) => ({
      ...prev,
      ...updates,
      updatedAt: new Date().toISOString(),
    }));
  };

  const resetDispute = () => {
    setDispute(null);
    localStorage.removeItem('dispute');
  };

  const value = {
    dispute,
    setDispute,
    updateDispute,
    resetDispute,
    loading,
    setLoading,
    error,
    setError,
  };

  return (
    <DisputeContext.Provider value={value}>
      {children}
    </DisputeContext.Provider>
  );
};

export default DisputeContext;
